import { useRef } from "react";

const CustomeModal = ({ onSubmitProp = () => { }, cancelText = 'لغو', submitText = 'تایید', bodyText = '', isLoading }) => {

    const closeModalBtn = useRef(null);

    const onSubmit = async () => {
        await onSubmitProp()
        closeModalBtn.current.click()
    }

    return (
        <div
            className="modal fade"
            id="customeModal"
            tabIndex="-1"
            aria-labelledby="customeModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5
                            className="modal-title"
                            id="customeModalLabel"
                            data-bs-dismiss="modal"
                        >
                            {submitText}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            ref={closeModalBtn}
                            data-bs-dismiss="modal"
                            aria-label="بستن"
                        ></button>
                    </div>
                    <div className="modal-body">{bodyText}</div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            {cancelText}
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={onSubmit}
                            disabled={isLoading}
                        >
                            {isLoading ? "در حال انجام..." : submitText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CustomeModal